import { useState } from "react";
import { hace, instante } from "../../shared/ficha";

/* El bloque de radicación DNRPA de la ficha: en qué Registro Seccional está
 * inscripta la unidad, y la dirección de ese registro.
 *
 * ── UN SOLO REGISTRO, NO UNA LISTA ────────────────────────────────────────
 *
 * A diferencia de Multas, acá no hay "actas" que se acumulan: es un estado
 * actual que se pisa en cada consulta nueva, así que no hace falta tabla ni
 * checkbox -- son datos, se muestran y listo.
 *
 * ── ES UN GASTO A PROPÓSITO, MISMO CRITERIO QUE MULTAS ───────────────────
 *
 * El captcha acá es una imagen de texto (no reCAPTCHA v2) y sale más
 * barato, pero sigue siendo un captcha real resuelto en cada consulta -- no
 * se dispara solo al abrir la ficha.
 *
 * ── LO QUE ESTO NO AFIRMA ─────────────────────────────────────────────────
 *
 * No es titularidad (a nombre de quién está) ni fecha de alta -- DNRPA no
 * expone ninguna de las dos en esta consulta. Y no confirma que la patente
 * exista: es el Registro Seccional al que mapea el dominio, nada más. */

const BloqueRadicacion = ({ dominio, dato, puedeConsultar, onConsultar }) => {
  const [consultando, setConsultando] = useState(false);
  const [error, setError] = useState(null);

  const consultar = async () => {
    setConsultando(true);
    setError(null);
    try {
      await onConsultar();
    } catch (e) {
      setError(e?.message || "No se pudo consultar");
    } finally {
      setConsultando(false);
    }
  };

  return (
    <div>
      <div className="pf-multas-cab">
        <div>
          {dato?.consultada_en ? (
            <p className="tenue">
              Consultado {hace(dato.consultada_en)} ({instante(dato.consultada_en)})
            </p>
          ) : (
            <p className="tenue">Nunca se consultó este dominio.</p>
          )}
        </div>
        {puedeConsultar && dominio && (
          <button
            type="button"
            className="pf-mover__btn"
            disabled={consultando}
            onClick={consultar}
            title="Consulta real contra DNRPA. Suele resolver en menos de un minuto."
          >
            {consultando ? "Consultando…" : "Consultar ahora"}
          </button>
        )}
      </div>

      {error && <p className="pf-nopude">{error}</p>}

      {!dato ? (
        <p className="tenue">Sin datos todavía — pedí una consulta.</p>
      ) : (
        <>
          <p className="pf-dato">
            <b>Registro Seccional</b>{" "}
            {dato.registro_numero ? `${dato.registro_numero} - ` : ""}
            {dato.registro_nombre || "—"}
          </p>
          <p className="pf-dato">
            <b>Dirección</b> {dato.direccion || "—"}
          </p>
          <p className="pf-dato">
            <b>Localidad</b> {dato.localidad || "—"}
            {dato.provincia ? `, ${dato.provincia}` : ""}
            {dato.codigo_postal ? ` (${dato.codigo_postal})` : ""}
          </p>
          {dato.telefono && (
            <p className="pf-dato">
              <b>Teléfono del registro</b> {dato.telefono}
            </p>
          )}
        </>
      )}
    </div>
  );
};

export default BloqueRadicacion;
